import { isFeatureEnabled } from 'owa-feature-flags';
import type WebSessionType from 'owa-service/lib/contract/WebSessionType';
import { getAccountScopeUserSettings } from 'owa-session-store';
import type { MailboxInfo } from 'owa-client-types';

export default function getRoutingKeyPrefixForSmtpAddress(mailboxInfo: MailboxInfo): string {
    const userConfiguration = getAccountScopeUserSettings(mailboxInfo);

    // This shouldn't happen in production, but if it does we'll have a hint.
    if (!userConfiguration || !userConfiguration.SessionSettings) {
        return 'no-routing-key:';
    }

    if (userConfiguration.SessionSettings.WebSessionType === 0) {
        // This is rolling out now, but gated by CAFE support.
        // https://exp.microsoft.com/a/feature/e4b89f0c-6e3d-4a5d-b6d3-c2d9deccdf1c
        if (isFeatureEnabled('doc-attachment-routingKeyAadSmtp')) {
            // The prefix was originally "AAD-SMTP" but has changed to just "SMTP".
            // The feature ID was created prior to that change.
            // https://substrate.microsoft.net/documentation/Develop/Authentication/Best-practices/Routing-best-practices#
            return 'SMTP:';
        } else {
            return '';
        }
    } else {
        return 'MSA:';
    }
}
